const color = {
  red: '#f94144',
  orange: '#f3722c',
  yellow: '#f9c74f',
  green: '#90be6d',
  blue: '#577590',
  black: '#252525',
  pink: '#d8737f',
  purple: '#685d79'
};

const fontSize = {
  sm: '0.8rem',
  base: '1rem',
  lg: '1.25rem',
  xl: '1.5rem'
};

const theme = {
  color,
  fontSize
};

export default theme;
